export default {
  getFullName(customer) {
    if (customer.is_business) {
      return customer.business_name;
    }
    if (customer.initials) {
      let initials = customer.initials.toUpperCase();
      if (initials.trim().slice(-1) !== ".") initials += ".";
      return `${initials} ${customer.suffix ? `${customer.suffix} ` : ""}${customer.last_name ? `${customer.last_name} ` : ""} ${customer.first_name ? `(${customer.first_name})` : ""}`;
    }
    return `${customer.first_name ? `${customer.first_name} ` : ""}${customer.suffix ? `${customer.suffix} ` : ""}${customer.last_name ? `${customer.last_name} ` : ""}`;
  },
  getCleanName(customer) {
    if (customer.is_business) {
      return customer.business_name.replace(/<([^>]+)>/g, "");
    }
    return customer.name.replace(/<([^>]+)>/g, "").replace(/&[^&;]+; /g, "");
  },
};
